import React from 'react';
import { Box, Typography } from '@mui/material';

const AdminEmail = () => {
    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center', 
            height: '100vh', 
            bgcolor: '#1a1a1a', 
            color: 'white' 
        }}>
            <Typography variant="h3" gutterBottom>
                Email Under Construction
            </Typography>
            <Typography variant="h6">
                This page is currently under construction. Please check back later.
            </Typography>
        </Box>
    );
};

export default AdminEmail;